import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { ActivatedRoute, Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';
import { UlipService } from '../../services/Ulip/ulip.service';
import { NewUlipComponent } from '../new-ulip/new-ulip.component';

@Component({
  selector: 'app-transporter-vehicle-driver-card-modal',
  templateUrl: './transporter-vehicle-driver-card-modal.component.html',
  styleUrls: ['./transporter-vehicle-driver-card-modal.component.scss']
})
export class TransporterVehicleDriverCardModalComponent implements OnInit, OnChanges {

  @Input() params: any;
  @Input() navigateBackId: any;
  @Input() FTLType: any;
  CompanyId: any;
  userId: any;
  data: any= {};
  apiUrl: any = environment.apiUrl;
  vehicleUtilizationPercent: any;
  vehicleCbmPercent: any;//

  isMobileView: any;
  sarathiData: any;
  // isDriverValid: boolean = false;
  isDriverValid: boolean | null = null;
  isVehValid: boolean | null = null;
  isDriverDetailsVisible: boolean = false;
  vahanData: any;
  // Added by priya - 21/01/2026 - cn(PRIYA-JAN26-013)
  @ViewChild('ulipComp') ulipComp: NewUlipComponent; 
  InsuranceStatus: any;
  
  @Output() onCloseEvent = new EventEmitter<any>();

  constructor(
    private orderService: OrdersService,
    private router: Router,
    private route: ActivatedRoute,
    private _appService: appService,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private modalService: NgbModal,
    private Ulip: UlipService // Added by priya - 21/01/2026 - Importing ulip service for using common function - cn(PRIYA-JAN26-013)

  ) { }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    // if (this.params) {
    //   this.getTransporterVehicleDriver(this.params);
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['params'] && this.params) {
      this.getTransporterVehicleDriver(this.params);
    }
  }

  getTransporterVehicleDriver(obj) {
    this._appService.Post("OrdersByVehicle", "getTransporterVehicleDriver", obj).subscribe(
      (response) => {
        if (response && response.length > 0) {

        console.log('getTransporterVehicleDriver', response);
        this.data = response[0];

        const totalWeight = response[0].TotalTripProductWeight || 0;
        const vehicleWeight = response[0].vehicleWeights || 0;

        const totalProductCbm = response[0].TotalTripProductCBM || 0;
        const vehicleCbm = response[0].vehicleCBM || 0;

        if (vehicleWeight > 0) {
          this.vehicleUtilizationPercent = ((totalWeight / vehicleWeight) * 100).toFixed(2);
          console.log('Vehicle Utilization %:', this.vehicleUtilizationPercent);
        } else {
          this.vehicleUtilizationPercent = '0';
        }

        if (vehicleCbm > 0) {
          this.vehicleCbmPercent = ((totalProductCbm / vehicleCbm) * 100).toFixed(2);
        } else {
          this.vehicleCbmPercent = '0';
        }

        if (this.data.LastVerifiedULIP && this.data.DriverValidity) {
          const today = new Date().toISOString().split('T')[0] + 'T00:00:00';
          this.isDriverValid = this.data.DriverValidity > today;
        } else {
          this.isDriverValid = false;
        }

        this.ShowDriverDetails(this.data.LicenseNo);
        this.ShowVehicleDetails(this.data.vehicleNumber)
        }else{
          this.data = {};
          this.isDriverValid = false;
        }
      },
      (error) => {
        console.error("Failed to retrieve data ", error);
      }

    );

  }

  closeModal() {
    // this.activeModal.close(); 
    // this.activeModal.dismiss();
    this.onCloseEvent.emit();
  }

  openPhoneHyperLink(phone: any) {
    const phoneLink = "tel:+" + phone;
    window.location.href = phoneLink;
  }

  openEmailHyperLink(email: any) {
    const phoneLink = "mailto:+" + email;
    window.location.href = phoneLink;
  }

  navigateToTransporter(Id, type) {
    if (Id) {
      let Url = '';

      if (this.FTLType == 'FTL') {
        Url = 'FtlList/view/' + this.navigateBackId + '?Type=' + this.FTLType + '&searchValue=';
      } else if (this.FTLType == 'ContainerMovement') {
        Url = 'Container-Movement/view/' + this.navigateBackId + '?Type=' + this.FTLType + '&searchValue=';
      }
      localStorage.setItem('previousPageUrl', Url);
      if (type === 'Transporter') {
        this.router.navigateByUrl(`/NewNetwork/view/${Id}`);
        // this.activeModal.dismiss();
        this.onCloseEvent.emit();
      } else if (type === 'Vehicle') {
        this.router.navigateByUrl(`/NewVehicleMaster/view/${Id}`);
        // this.activeModal.dismiss();
        this.onCloseEvent.emit();
      } else if (type === 'Driver') {
        this.router.navigateByUrl(`/NewDriver/view/${Id}`);
        // this.activeModal.dismiss();
        this.onCloseEvent.emit();
      }
    } else {
      console.error('ID is undefined');
    }
  }

  // Added by priya - 21/01/2026 - validating driver ulip using common service - cn(PRIYA-JAN26-013)
  ValidateDriverViaUlip(P1, P2) {
    const licenseNo = P1;
    const DateOfBirth = P2;
    return this.Ulip.ValidateDriverUlip(licenseNo, DateOfBirth).then(res => {
      this.sarathiData = res.sarathiData;
      if (this.sarathiData && Object.keys(this.sarathiData).length > 0) {
        this.isDriverValid = true;
        this.getTransporterVehicleDriver(this.params);
      } else {
        this.isDriverValid = false;
        return Promise.resolve();
      }
    }).catch(err => {
      this.isDriverValid = false;
      return Promise.resolve();
    });
  }

  // ValidateDriverViaUlip(P1,P2){
  //   const licenseNo=P1;
  //   const DateOfBirth=P2;
  //   console.log(licenseNo,DateOfBirth);
  //   this._appService.GetByTwoId("VehicleMaster","GetNewSarathiData",licenseNo,DateOfBirth).subscribe(
  //     (response)=>{
  //       this.sarathiData = response.sarathiData;
  //       if (this.sarathiData && Object.keys(this.sarathiData).length > 0) {
  //         var currentDATE1 = new Date();
  //         var formattedDate1 = currentDATE1.toISOString().split('T')[0] + 'T00:00:00';
  //         if (this.sarathiData.DlValidity > formattedDate1) {
  //           this.isDriverValid = true;
  //           this.getTransporterVehicleDriver(this.params);
  //         } else {
  //           this.isDriverValid = false;
  //            this.toastr.warning("Driver license is expired.");
  //         }
  //       } else {
  //         this.toastr.warning("No driver data found for the provided license number and date of birth.");
  //         this.isDriverValid = false;
  //       }
  //     },
  //     (err)=>{
  //       this.toastr.error("An error occured !", "error");
  //       this.isDriverValid = false;
  //     }
  //   );
  // }

  // Added by priya - 21/01/2026 - getting driver ulip data using common service - cn(PRIYA-JAN26-013)
  ShowDriverDetails(LicenseNo) {
    this.Ulip.GetDriverUlipData(LicenseNo).then(res => {
      if (Array.isArray(res) && res.length > 0) {
        this.sarathiData = res[0];
      } else {
        this.sarathiData = null;
      }
    })
    .catch(err => {
      console.log(err)
    });
  }

  // ShowDriverDetails(licenseNo){
  //   this._appService.GetByOneParam('VehicleMaster','GetDriverULIPData',licenseNo).subscribe(
  //     (response)=>{
  //       if (Array.isArray(response) && response.length > 0) {
  //         this.sarathiData = response[0];
  //       } else {
  //         this.sarathiData = null;
  //       }
  //       console.log('=(:<',response);
  //     },
  //     (error)=>{
  //       this.toastr.error("An error occured !", "error");
  //     }
  //   );
  // }

  toggleDriverDetails() {
    this.isDriverDetailsVisible = !this.isDriverDetailsVisible;
  }

  // Added by priya - 21/01/2026 - validating driver ulip using common service - cn(PRIYA-JAN26-013)
  ValidateVehicleViaUlip(P1) {
    const vehicleNo = P1;
    return this.Ulip.ValidateVehicleUlip(vehicleNo).then(res => {
      this.vahanData = res.vahanData;
      if (this.vahanData && Object.keys(this.vahanData).length > 0) {
        this.isVehValid = true;
        this.getTransporterVehicleDriver(this.params);
      } else {
        this.isVehValid = false;
        return Promise.resolve();
      }
    }).catch(err => {
      this.isVehValid = false;
      return Promise.resolve();
    });
  }

  // ValidateVehicleViaUlip(P1){
  //   const vehicleNo=P1;
  //   this._appService.GetByOneParam("VehicleMaster","GetNewVahanData",vehicleNo).subscribe(
  //     (response)=>{
  //       this.vahanData = response.vahanData;
  //       if (this.vahanData && Object.keys(this.vahanData).length > 0) {
  //          const currentDate = new Date();
  //         const insuranceDate = this.parseDate(this.vahanData.RcInsuranceUpto);
  //         const fitDate = this.parseDate(this.vahanData.RcFitUpto);
  //         const taxDate = this.parseDate(this.vahanData.RcTaxUpto);

  //         if (
  //             !isNaN(insuranceDate.getTime()) &&
  //             !isNaN(fitDate.getTime()) &&
  //             !isNaN(taxDate.getTime()) &&
  //             insuranceDate > currentDate &&
  //             fitDate > currentDate &&
  //             taxDate > currentDate
  //         ) {
  //            this.isVehValid = true;
  //           this.getTransporterVehicleDriver(this.params);
  //         } else {
  //           this.isVehValid = false;
  //            this.toastr.warning("The vehicle's insurance, fitness, or tax is not valid.");
  //         }
  //       } else {
  //         this.toastr.warning("No vehicle data found for the provided vehicle No.");
  //         this.isVehValid = false;
  //       }
  //     },
  //     (err)=>{
  //       this.toastr.error("An error occured !", "error");
  //       this.isVehValid = false;
  //     }
  //   );
  // }

  private parseDate(dateStr: string): Date {
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split('-');
      return new Date(`${year}-${month}-${day}`);
    }
    return new Date(dateStr);
  }

  // Added by priya - 21/01/2026 - Getting vehicle ulip data - cn(PRIYA-JAN26-013)
  ShowVehicleDetails(VehicleNo) {
    this.Ulip.GetVehicleUlipData(VehicleNo).then(res => {
      if (Array.isArray(res) && res.length > 0) {
        this.vahanData = res[0];
        const currentDate = new Date();
        if (currentDate > new Date(this.vahanData.RegVehicleInsuranceUpto)) {
          this.InsuranceStatus = 'Expired';
        } else {
          this.InsuranceStatus = 'Insured';
        }
      } else {
        this.vahanData = null;
      }
    })
    .catch(err => {
      console.log(err)
    });
  }

  // Added by priya - 22/01/2026 - Get negative left days - cn(PRIYA-JAN26-013)
  isNegative(str: string): boolean {
    if (!str) return false;
    // Check if string contains a negative number
    const match = str.match(/-\d+/);
    return !!match;
  }

}
